<template>
  <Room/>
</template>

<script>
import Room from '@/components/Room'
export default {
  name: 'Home',
  components: {
    Room
  }
}
</script>
